// extracted by mini-css-extract-plugin
export default {"embed-form":"nLXiXM","embedForm":"nLXiXM","size-picker":"Kcs7lV","sizePicker":"Kcs7lV"};